// extracted by mini-css-extract-plugin
export var sliderRange = "_og-2";
export var sliderRoot = "_og-0";
export var sliderThumb = "_og-3";
export var sliderTrack = "_og-1";